import { useEffect, useContext } from "react";
import "../styles/gafe-styles.css";
import { DotLoader } from "react-spinners";
import Logo from ".././../assests/svg/Logo.svg";
import { ProductContext } from "../restaurant/Context";
import { useNavigate, useParams } from "react-router-dom";
import { get } from "lodash";

const LinkMenuView = ({ link }: { link: string }) => {
  const params = useParams();
  let navigate = useNavigate();
  const { shop, setQrId, loadingMenu, setShortCode, fetchDataForQrId } =
    useContext(ProductContext);

  useEffect(() => {
    if (params && params.shortCode) {
      let qrId;
      if (params.id) {
        qrId = `${params.shortCode}/${params.id}`;
        setQrId(qrId);
      } else {
        qrId = `${params.shortCode}`;
      }
      fetchDataForQrId(qrId);
      setShortCode(params.shortCode);
    }
  }, [params, navigate]);

  const onClickMenu = () => {
    if (shop) {
      navigate(`/restaurant/${shop.shortCode}`);
    }
  };

  return (
    <div className="home-wrapper" style={{ background: "#fff" }}>
      <div className="home-wrapper-info">
        <div className="home-header-wrapper">
          <div className="logo-wrapper">
            <img src={"/assets/gafe/gafe_logo.jpg"} alt="Gafe Restaurant" />
          </div>
          <div className="text-wrapper">
            <div className="desc-text">{"Welcome to "}</div>
            <div className="title-text">{`${get(shop, "shopName", "")}`}</div>
          </div>
        </div>
        <div className="home-header-wrapper">
          {/* <button onClick={() => onClickMenu()} className="button">
            {loadingMenu ? (
              <DotLoader color={"#6D71F9"} loading={loadingMenu} size={25} />
            ) : (
              "See menu"
            )}
          </button> */}
          <button
            onClick={() => {
              window.open(
                "https://www.tripadvisor.com/Restaurant_Review-g297896-d28651263-Reviews-Gafe-Galle_Galle_District_Southern_Province.html?m=69573",
                "_blank"
              );
            }}
            className="button"
          >
           Trip Advisor
          </button>
          <button
            onClick={() => {
              window.open(
                "https://share.google/FZGgn29nfPQAuEkUJ",
                "_blank"
              );
            }}
            className="button"
          >
           Google Review
          </button>
          <button
            onClick={() => {
              window.open(
                "https://drive.google.com/drive/folders/1Z4eWNV24YS_pwG8A8hYr0RP5oosJFi3D",
                "_blank"
              );
            }}
            className="button"
          >
            {loadingMenu ? (
              <DotLoader color={"#BF9C5D"} loading={loadingMenu} size={25} />
            ) : (
              "See menu"
            )}
          </button>
        
        </div>
      </div>
    </div>
  );
};
export default LinkMenuView;
